import type {
  CreateDecisionRequest,
  CreateStageRequest,
  CreateWorkflowRequest,
  DeleteStageRequest,
  EditStageRequest,
  EditWorkflowRequest,
  ReorderStageRequest,
} from 'shared/domain/workflow/requests';
import { stageSaver } from './addStage';
import { workflowSaver } from './addWorkflow';
import { decisionSaver } from './createDecision';
import { stageDeleter } from './deleteStage';
import { stageEditor } from './editStage';
import { workflowEditor } from './editWorkflow';
import { stageReorderer } from './reorderStage';

/** Workflow, stage and decision changes put on the HTTP queue; each resolves once queued. */
export const queueWorkflowChanges = {
  createWorkflow: ({ workflowCreateDto, projectId, uniqueId }: CreateWorkflowRequest): Promise<void> =>
    workflowSaver.execute(workflowCreateDto, projectId, uniqueId),

  editWorkflow: ({ workflowId, workflowUpdateDto, projectId, uniqueId }: EditWorkflowRequest): Promise<void> =>
    workflowEditor.execute(workflowId, workflowUpdateDto, projectId, uniqueId),

  createStage: ({ workflowId, stageCreateDto, projectId, uniqueId }: CreateStageRequest): Promise<void> =>
    stageSaver.execute(stageCreateDto, workflowId, projectId, uniqueId),

  editStage: ({ workflowId, stageId, stageUpdateDto, projectId, uniqueId }: EditStageRequest): Promise<void> =>
    stageEditor.execute(stageId, stageUpdateDto, workflowId, projectId, uniqueId),

  deleteStage: ({ workflowId, stageId, projectId, uniqueId }: DeleteStageRequest): Promise<void> =>
    stageDeleter.execute(stageId, workflowId, projectId, uniqueId),

  reorderStage: ({ workflowId, stageId, stageReorderDto, projectId, uniqueId }: ReorderStageRequest): Promise<void> =>
    stageReorderer.execute(stageId, stageReorderDto, workflowId, projectId, uniqueId),

  createDecision: ({ issueId, decisionDto, projectId, uniqueId }: CreateDecisionRequest): Promise<void> =>
    decisionSaver.execute(decisionDto, projectId, issueId, uniqueId),
};
